import {Component, ViewChild, ElementRef} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {CropperSettings, Bounds} from 'ng2-img-cropper';
import {TGoogleAnalytic, Util} from "../../../app/util";
import {ProfileService} from "../../../providers/profile-service";
import {TAction, TContatoTipo, TProfileFlag} from "../../../app/enum";
import {LogadoService} from '../../../providers/logado-service';

@Component({
    selector: 'page-profile-foto',
    templateUrl: 'profile-foto.html',
    providers: [ProfileService],
})

export class ProfileFotoPage {

    TContatoTipo: any = TContatoTipo;

    config: any;
    logado: any;
    rootile: any;
    copyile: any;

    picture: any;
    body64: any;

    name: string;
    etapa: number;

    cropperResult: any = {};
    cropperSettings: CropperSettings;

    croppedWidth: number;
    croppedHeight: number;

    @ViewChild('cropper', undefined) cropper: any;
    @ViewChild('cropInput') input: ElementRef;

    constructor(public navParams: NavParams, public viewCtrl: ViewController, public util: Util,
                public profileService: ProfileService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.navParams.get('copyile');

        if (this.etapa == 1) {

            /* Google Analytics */
            this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Foto', '/profile-foto');

        }

        if (this.etapa == 2) {
            this.picture = this.navParams.get('picture');
            this.body64 = this.navParams.get('body64');
        }

        this.settingCrop();
    }

    ionViewDidEnter() {

        if (this.etapa == 1) {

            let contato = this.copyile.Contatos.find(contato => contato.ContatoRede == TContatoTipo.coFace);
            if (contato && contato.ContatoFoto) {

                //Download Base64
                this.util.getBase64Image(contato.ContatoFoto)
                    .subscribe(
                        foto => this.pictureFile(foto, false),
                        erro => this.util.toastSimply('Não foi poossível capturar sua foto, selecione uma manualmente')
                    );

            }

        }

        if (this.etapa == 2) {

            this.cropper.setImage(this.picture);

        }

    }

    settingCrop() {

        //ETAPA-1 - Body
        //ETAPA-2 - Face
        let pictureW = (this.etapa == 1 ? CONFIG.data.pictureBodyWidth  : CONFIG.data.pictureFaceWidth);
        let pictureH = (this.etapa == 1 ? CONFIG.data.pictureBodyHeight : CONFIG.data.pictureFaceHeight);

        this.cropperSettings = new CropperSettings();
        this.cropperSettings.width         = pictureW;
        this.cropperSettings.height        = pictureH;

        this.cropperSettings.croppedWidth  = pictureW;
        this.cropperSettings.croppedHeight = pictureH;

        this.cropperSettings.minWidth      = pictureW;
        this.cropperSettings.minHeight     = pictureH;

        this.cropperSettings.canvasWidth   = (window.innerWidth >= 540 ? 520 : 300);
        this.cropperSettings.canvasHeight  = (window.innerWidth >= 540 ? 390 : 300);

        this.cropperSettings.noFileInput   = true;
        this.cropperSettings.dynamicSizing = false; // bugado
        this.cropperSettings.keepAspect    = true;

        this.cropperSettings.cropperDrawSettings.strokeColor = 'rgba(255,255,255,0.8)';
        this.cropperSettings.cropperDrawSettings.strokeWidth = 2;

        this.cropperSettings.cropperClass = "cropper";

    }

    pictureSend() {

        if (this.etapa == 1) {

            //#GAMBI - Não pode passar a funcao this.dismiss direto
            let onThen = () => this.dismiss();

            let objectData = {etapa: 2, rootile: this.rootile, copyile: this.copyile, picture: this.picture, body64: this.cropperResult.image.split(',')[1]};
            this.util.modalopen(ProfileFotoPage, 'wide', false, objectData, null, null, null, onThen)
                .subscribe();

        }

        if (this.etapa == 2) {

            this.copyile.Profile.ProfileFace64 = this.cropperResult.image.split(',')[1];
            this.copyile.Profile.ProfileBody64 = this.body64;
            this.profileSave();
            this.dismiss();

        }

    }

    pictureCrop(bounds: Bounds) {

        this.croppedHeight = bounds.bottom - bounds.top;
        this.croppedWidth  = bounds.right  - bounds.left;

    }

    pictureFile(data64, concatTag: boolean) {

        if (!data64) return;

        this.picture = new Image;
        this.picture.src = (concatTag ? 'data:image/jpeg;base64,' : '') + data64;
        this.picture.onload = () => this.cropper.setImage(this.picture);

    };

    pictureOpen() { // só funciona na etapa 1

        this.util.pictureOpen(this.input).subscribe(
            data => this.pictureFile(data, true),
            erro => this.util.alertSimply(erro)
        );

    }

    pictureLoad(eventOrBase64) { // só funciona na etapa 1

        this.util.pictureLoad(eventOrBase64, false).subscribe(
            data => this.pictureFile(data, false),
            erro => this.util.alertSimply(erro)
        );

    }

    pictureFace() {

        //Contato Facebook
        let contato = this.copyile.Contatos.find(CO => CO.ContatoRede == TContatoTipo.coFace);

        let loading = this.util.loadingDots('Capturando foto...');
        loading.present();

        this.profileService.contato(TAction.acFoto, this.copyile.Profile.ProfileID, contato)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    contato.ContatoFoto = data.Contatos[0].ContatoFoto;
                    this.pictureSend();

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }

    profileSave() {

        //Criando novo registro...
        let profileNovo = (this.copyile.Profile.ProfileFlag == TProfileFlag.pfGhost);
        if (profileNovo) return;

        let onDone = () => {

            delete this.rootile.Profile.ProfileFace64;
            delete this.rootile.Profile.ProfileBody64;

            delete this.copyile.Profile.ProfileFace64;
            delete this.copyile.Profile.ProfileBody64;

            this.copyile.Profile.ProfileFace += '0';
            this.copyile.Profile.ProfileBody += '0';

        };

        //ProfileSave
        this.profileService.profile(TAction.acSave, this.copyile.Profile.ProfileID, this.copyile.Profile)
            .subscribe(
                data => onDone(),
                erro => this.util.alertResult(erro, ()=> onDone())
            );

    }

    dismiss() {

        this.viewCtrl.dismiss();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/profile-foto/profile-foto.ts